// Token gaya Jawsel untuk kontrol mengambang halaman kota publik (HP-first)
export const C = {
  ink: "#141414", sub: "#8a8776", line: "#ece9dc", cream: "#f4f1e6",
  blue: "#0000CD", blueSoft: "rgba(0,0,205,0.12)", danger: "#dc2626",
};
export const FONT = "'Plus Jakarta Sans', system-ui, sans-serif";
export const SAFE_TOP = "env(safe-area-inset-top, 0px)";
export const SAFE_BOTTOM = "env(safe-area-inset-bottom, 0px)";
export const DOCK_H = 150;         // perkiraan tinggi dock bawah (px) — dipakai untuk pas-layar & posisi kartu di atasnya
export const SIDE_DOCK_W = 64;     // lebar dock samping + margin — pil radio tidak boleh menindihnya
export const IG_JAWSEL = "@jawsel.fun";  // akun Instagram resmi untuk petunjuk jadi warga

export const fmtWaktu = iso => {
  if (!iso) return "";
  const d = new Date(iso), diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "baru saja";
  if (diff < 3600) return `${Math.floor(diff / 60)} mnt lalu`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} jam lalu`;
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: diff > 300 * 86400 ? "numeric" : undefined });
};
// Nama tampilan kota — diatur Super Admin (Pengaturan → Nama Kota); ID/slug kota tidak pernah berubah.
// Peta nama dimuat dari /api/public/cities (muatNamaKota) dan di-cache di localStorage agar tampil instan.
const NAMA_KEY = "jawsel_nama_kota";
let NAMA_KOTA = (() => { try { return JSON.parse(localStorage.getItem(NAMA_KEY)) || {}; } catch { return {}; } })();
export const namaKota = id => (id ? NAMA_KOTA[id] || id.charAt(0).toUpperCase() + id.slice(1) : "Jawsel");
export const setNamaKota = peta => { NAMA_KOTA = peta || {}; localStorage.setItem(NAMA_KEY, JSON.stringify(NAMA_KOTA)); };
export const adaCacheNamaKota = () => Object.keys(NAMA_KOTA).length > 0;
export const muatNamaKota = () => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/cities`).then(r => r.json())
  .then(d => { setNamaKota(Object.fromEntries((d.cities || []).map(c => [c.city_id, c.city_name]))); }).catch(() => {});

// Glass (kaca buram) — bahasa visual kontrol di atas peta: tembus pandang, blur kuat, tepi tipis.
// Nilai warna lewat CSS variable (diset di root Kota.jsx oleh glassVars) agar kaca bisa menggelap lembut saat malam.
// Biru Jawsel hanya aksen kecil (ikon aktif, titik, teks penanda) — tidak pernah blok warna besar.
export const GLASS = {
  bg: "var(--g-bg)", bgStrong: "var(--g-bg-strong)", inner: "var(--g-inner)", innerOn: "var(--g-inner-on)",
  accentBg: "var(--g-accent-bg)", accent: "var(--g-accent)", border: "1px solid var(--g-border)", blur: "blur(22px) saturate(1.5)",
  shadow: "var(--g-shadow)", ink: "var(--g-ink)", sub: "var(--g-sub)", handle: "var(--g-handle)",
};
// Tema kaca siang (putih) vs malam (arang lembut) — dipakai sebagai style root
export const glassVars = malam => (malam ? {
  "--g-bg": "rgba(30,30,36,0.55)", "--g-bg-strong": "rgba(30,30,36,0.78)", "--g-inner": "rgba(255,255,255,0.08)", "--g-inner-on": "rgba(255,255,255,0.16)",
  "--g-accent-bg": "rgba(143,143,255,0.18)", "--g-accent": "#9f9fff", "--g-border": "rgba(255,255,255,0.16)",
  "--c-green": "#7ee2ad", "--c-green-bg": "rgba(24,154,91,0.26)", "--c-blue": "#b4b4ff", "--c-blue-bg": "rgba(143,143,255,0.22)",
  "--c-red": "#fca5a5", "--c-red-bg": "rgba(220,38,38,0.26)", "--c-amber": "#fcd34d", "--c-amber-bg": "rgba(183,121,31,0.28)",
  "--c-gray": "rgba(244,243,238,0.72)", "--c-gray-bg": "rgba(255,255,255,0.12)",
  "--g-shadow": "0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.12)", "--g-ink": "#f4f3ee", "--g-sub": "rgba(244,243,238,0.62)", "--g-handle": "rgba(255,255,255,0.28)",
} : {
  "--g-bg": "rgba(255,255,255,0.56)", "--g-bg-strong": "rgba(255,255,255,0.78)", "--g-inner": "rgba(255,255,255,0.42)", "--g-inner-on": "rgba(255,255,255,0.78)",
  "--g-accent-bg": "rgba(0,0,205,0.09)", "--g-accent": C.blue, "--g-border": "rgba(255,255,255,0.7)",
  "--c-green": "#189a5b", "--c-green-bg": "#d6f2e2", "--c-blue": C.blue, "--c-blue-bg": C.blueSoft, "--c-red": C.danger, "--c-red-bg": "#fee2e2",
  "--c-amber": "#b7791f", "--c-amber-bg": "#fdf1d6", "--c-gray": C.sub, "--c-gray-bg": C.cream,
  "--g-shadow": "0 10px 30px rgba(20,20,20,0.10), inset 0 1px 0 rgba(255,255,255,0.8)", "--g-ink": "#1d1d1f", "--g-sub": "rgba(29,29,31,0.58)", "--g-handle": "rgba(29,29,31,0.18)",
});
const GLASS_TRANSITION = "background-color .8s ease, color .8s ease, border-color .8s ease, box-shadow .8s ease";
export const glassBox = {
  background: GLASS.bg, backdropFilter: GLASS.blur, WebkitBackdropFilter: GLASS.blur, border: GLASS.border, boxShadow: GLASS.shadow, color: GLASS.ink, transition: GLASS_TRANSITION,
};
export const glassInner = (on = false) => ({ background: on ? GLASS.innerOn : GLASS.inner, border: `1px solid ${on ? "var(--g-border)" : "transparent"}`, color: GLASS.ink, transition: GLASS_TRANSITION });

// Pil kaca mengambang (teks/ikon)
export const pill = {
  display: "inline-flex", alignItems: "center", gap: 8, height: 38, padding: "0 14px",
  ...glassBox, borderRadius: 99, fontFamily: FONT, fontSize: 12.5, fontWeight: 600, letterSpacing: -0.1,
  whiteSpace: "nowrap", textDecoration: "none",
};

// Tombol bulat kaca 42px (target sentuh) — aktif = sentuhan biru tipis
export const roundBtn = (active = false) => ({
  width: 42, height: 42, borderRadius: 99, cursor: "pointer",
  display: "grid", placeItems: "center", padding: 0,
  ...glassBox, background: active ? GLASS.accentBg : GLASS.bg, color: active ? GLASS.accent : GLASS.ink,
  transition: "background-color .15s, color .15s, transform .12s",
  WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
});
